import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { Icon, icon } from 'leaflet';
// L.Icon.Default.imagePath = 'assets/leaflet/marker.png';
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrl: './map.component.scss',
})
export class MapComponent implements OnInit, AfterViewInit {
  private map!: L.Map;
  @Input() lat = 48.8783389;
  @Input() lon = 2.3063031;
  @Input() address: any;
  private defaultIcon: Icon = icon({
    iconUrl: 'assets/leaflet/marker.png',
    shadowUrl: 'assets/leaflet/marker-shadow.png',
    iconSize: [25, 30], // => random values you have to choose right ones for your case
    iconAnchor: [20, 51], // => random values too
  });
  markers: L.Marker[] = [
    L.marker([this.lat, this.lon], { icon: this.defaultIcon }), // Amman
  ];

  constructor() {}

  ngOnInit() {
    this.markers = [
      L.marker([this.address.lat, this.address.lon], {
        icon: this.defaultIcon,
      }), // Amman
    ];
  }

  ngAfterViewInit() {
    this.initializeMap();
    this.addMarkers();
    this.centerMap();
    this.markers = [
      L.marker([this.address.lat, this.address.lon], {
        icon: this.defaultIcon,
      }), // Amman
    ];
  }

  private initializeMap() {
    const baseMapURl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    this.map = L.map('map', {
      center: [this.address.lat, this.address.lon],
      zoom: 15,
    });
    L.tileLayer(baseMapURl).addTo(this.map);
  }

  private addMarkers() {
    // Add your markers to the map
    this.markers.forEach((marker) => marker.addTo(this.map));
  }

  private centerMap() {
    // Create a LatLngBounds object to encompass all the marker locations
    const bounds = L.latLngBounds(
      this.markers.map((marker) => marker.getLatLng())
    );

    // Fit the map view to the bounds
    this.map.fitBounds(bounds);
  }
}
